import { useContext } from "react";
import { UserContext } from "../context/userContext";

export function usePermission(permission) {
  const { user } = useContext(UserContext);

  // Safety check: ensure user and permissions structure exists
  if (!user || !user.permissions || !user.permissions.rolePermissions) {
    return false; // Default to no permission if user data isn't loaded yet
  }

  return user.permissions.rolePermissions.hasOwnProperty(permission);
}
